import { type ReactNode, useEffect, useState } from "react";

import { twMerge } from "@/utils/twMerge";

export function FormField({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={twMerge("w-full flex flex-col mb-5", className)}>{children}</div>;
}

export function FormFieldLabel({ htmlFor, children }: { htmlFor: string; children: ReactNode }) {
  return (
    <label
      htmlFor={htmlFor}
      className="mb-1.5 text-[12px] leading-[14px] font-mono uppercase tracking-tight text-gray-500"
    >
      {children}
    </label>
  );
}

export function FormFieldError({
  message,
  className,
}: {
  className?: string;
  message: string | null;
}) {
  const [shownError, setShownError] = useState<string | null>(message);
  useEffect(() => {
    if (message != null) setShownError(message);
  }, [message]);
  return (
    <div
      role="alert"
      aria-hidden={!message}
      className={twMerge(
        "text-error w-full text-size-14 overflow-hidden",
        "transition-max-height duration-200 ease-in-out delay-200 motion-reduce:transition-none",
        "mt-1",
        !message && "max-h-0 mt-0 delay-0",
        className,
      )}
    >
      {shownError}
    </div>
  );
}

export function FormFieldHint({ message, className }: { message: string; className?: string }) {
  if (!message) {
    return null;
  }

  return (
    <div
      className={twMerge("mt-2.5 font-sans text-size-14 text-gray-500 tracking-tight", className)}
    >
      {message}
    </div>
  );
}
